/**
 * Helper function to safely convert values to numbers
 * @param value - The value to convert to a number
 * @param fallback - The fallback value to return if conversion fails (default: 0)
 * @returns The converted number or fallback value
 */
export const safeNumber = (value: any, fallback = 0): number => {
  if (value === null || value === undefined || value === '') return fallback;
  const num = Number(value);
  return isNaN(num) ? fallback : num;
};
